/* global $, breakdown_data */
/* eslint-disable no-new, import/no-extraneous-dependencies, new-cap, no-param-reassign */
import table from 'bam-node-savant-table/table'
import LoadCatchRates from './d3.catch-rate'

/* requirejs.config({
    paths: {
        jquery: "jquery",
        catchRates: "../scripts/d3.catch-rate",
        responsiveDataTable:
            "responsive-datatables/src/static/fed-package-responsive-datatables",
    },
});

define(["jquery", "catchRates", "responsiveDataTable"], function (
    $,
    CatchRates,
    responsiveDataTable
) { */
// define(function( require, exports, module ) {
/* var $ = require('jquery');
  var ui = require('jquery-ui/jquery-ui');
  var CatchRates = require('../../scripts/catch-probability/d3.catch-rate'); */

//    var responsiveDataTable = require('');

$(document).ready(() => {
    let width = $('#catch_rate_chart').width()
    let height
    if (width > 1024 || width === 0) {
        width = 1024
        height = width / 2.55
    } else {
        width /= 1.05
        height = width / 2.55
    }

    new LoadCatchRates({
        width,
        height,
        div_id: 'catch_rate_chart',
    })

    const headers = [
        {
            name: 'Hang Time',
            field: 'opportunity_time',
            headerClass: 'align-left',
            fieldClass: 'tr-data align-left',
        },
        {
            name: 'Balls Landed',
            field: 'balls_landed',
            type: 'number',
            headerClass: 'align-left',
            fieldClass: 'tr-data align-left',
        },
        {
            name: 'Batted Ball Events',
            field: 'balls_in_play',
            type: 'number',
            headerClass: 'align-left',
            fieldClass: 'tr-data align-left',
        },
        {
            name: 'Catch Rate',
            field: 'catch_rate',
            type: 'number',
            headerClass: 'align-left',
            fieldClass: 'tr-data align-left',
        },
    ]

    breakdown_data.map((d) => {
        d.id = d.opportunity_time.replace('.', '')
        return d
    })

    new table({
        id: 'breakdown',
        headers,
        data: breakdown_data,
        subDataId: 'id',
    })

    $('#breakdown').on(
        'click',
        '.default-table-row',
        function handleRowClick() {
            const hangTime = this.id.split('_')[1]
            const hangTimeNumber = `${hangTime.substring(
                0,
                1
            )}.${hangTime.substring(1, 2)}`
            if ($(`#breakdown-trSub_${hangTime}`).is(':visible') === true) {
                $(`#breakdown-trSub_${hangTime}`).hide()
            } else {
                $.ajax({
                    method: 'GET',
                    url: 'statcast_catch_probability',
                    data: {
                        hang_time: hangTimeNumber,
                    },
                }).done((data) => {
                    $(`#breakdown-tdSub_${hangTime}`).html(
                        `<div id="data_${hangTime}" style="padding: 1rem;"></div>`
                    )
                    $(`#breakdown-trSub_${hangTime}`).show()

                    new table({
                        id: `data_${hangTime}`,
                        headers: [
                            {
                                name: 'Distance',
                                field: 'distance',
                                type: 'number',
                                headerClass: 'align-left',
                                fieldClass: 'tr-data align-left',
                            },
                            {
                                name: 'Balls Landed',
                                field: 'balls_landed',
                                type: 'number',
                                headerClass: 'align-left',
                                fieldClass: 'tr-data align-left',
                            },
                            {
                                name: 'Batted Balls',
                                field: 'balls_in_play',
                                type: 'number',
                                headerClass: 'align-left',
                                fieldClass: 'tr-data align-left',
                            },
                            {
                                name: 'Catch Rate',
                                field: 'catch_rate',
                                type: 'number',
                                headerClass: 'align-left',
                                fieldClass: 'tr-data align-left',
                            },
                        ],
                        data,
                    })
                })
            }
        }
    )
})
// });
